export default "__VITE_ASSET__e0b782cf__"